import { render } from "./userComplaintDetail.vue?vue&type=template&id=5ca067f3&scoped=true"
import script from "./userComplaintDetail.vue?vue&type=script&lang=js"
export * from "./userComplaintDetail.vue?vue&type=script&lang=js"

import "./userComplaintDetail.vue?vue&type=style&index=0&id=5ca067f3&scoped=true&lang=css"
import "./userComplaintDetail.vue?vue&type=style&index=1&id=5ca067f3&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca067f3"]])

export default __exports__